export default "__VITE_ASSET__buj5Z32o__";